import AppAdapter from 'adapters/app';

class CategoryAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';
}

export default CategoryAdapter;